// extracted by mini-css-extract-plugin
export default {"createAccount":"CreateAccount_createAccount__vNCP1"};